
<div class="container">
    <h2>Average Performance</h2>

    <!-- <div>
        <strong>Expenses:</strong> {{totalExpenses | human}}
        <br>
        <strong>Revenue:</strong> {{totalRevenue | human}}
    </div> -->


    <!-- <google-chart #chart 
        style="width: 100%;height: 600px;background-color: transparent;" 
        [options]="chartOptions"
        [dynamicResize]="true" 
        [columns]="chartColumns" 
        [data]="weeks" 
        type="LineChart"></google-chart> -->


    <h3>Revenue per week</h3>

    <div class="weeks" *ngFor="let row of weeksRevenue">
        {{row.weekYear}} {{row.weekNumber}} - {{row.weekAmount | human}}
    </div>
</div>